<script>
import Vue from 'vue'
import axios from 'axios'
import Multiselect from 'vue-multiselect'
import appConfig from '@src/app.config'
import Layout from '@layouts/main'
import PageHeader from '@components/page-header'

import { required } from 'vuelidate/lib/validators'



/**
 * Agregar Conceptos Component
 */
export default {
  components: { Layout, PageHeader, Multiselect },
  page: {
    title: 'Pagos',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  data() {
    return {
      title: 'Pagos',
      fields: [
        { key: 'observacion', sortable: true, label: 'Descripción' },
        {
          key: 'importeFormat',
          sortable: true,
          label: 'Importe',
          thStyle: { width: '20%' },
        },
        {
          key: 'id',
          sortable: true,
          label: '',
          thStyle: { width: '20%' },
        },
      ],
      detallePago: {
        idDetallePago: '',
        descripcion: '',
        importe: 0.0,
      },
      form: {
        fomaPago: '',
        contribuyente: {
          contribuyenteId: '',
          rfc: '',
          razonSocial: '',
        },
        conceptos: [],
        importe: 0.0,
        importeFormat: '$0.0',
        tipoPago: '',
        estado: '',
        concepto: {
          conceptoId: '',
          descripcion: '',
          observacion: '',
          importe: 0.0,
        },
      },
      isLoadingComboConceptos: false,
      listadoConceptos: [],
      conceptoSeleccionado:null,
      requestComboConceptos: {
        perPage: 50,
        cuerrentPage: 0,
        filter: '',
      },
      isLoadingComboContribuyentes: false,
      listadoContribuyentes: [],
      requestComboContribuyentes: {
        perPage: 30,
        cuerrentPage: 0,
        filter: '',
      },
      items: [
        {
          text: 'Sistemas Tributario',
          href: '/',
        },
        {
          text: 'Pagos',
          href: '/pagos/add',
        },
        {
          text: 'Nuevo',
          active: true,
        },
      ],
      submitted: false,
      isBusy: false,
    }
  },
  validations: {
    form: {
      tipoPago: {
        required,
      },
      estado: {
        required,
      },      
      conceptos: {
        tieneConceptos(value) {
          return this.form.conceptos.length
        },
      
      },
    },
  },
  computed: {},
  mounted() {
    this.loadContribuyentes()
    this.loadConceptos()
  },
  methods: {
    _validations() {
      return new Promise((resolve) => {
        if (this.$v.$error || !this.$v.$pending) {
          return resolve()
        }
        let poll = setInterval(() => {
          if (!this.$v.$pending) {
            clearInterval(poll)
            resolve()
          }
        }, 200)
      })
    },
    async isValid() {
      this.$v.$reset()
      this.$v.$touch()
      await this._validations()
      return Promise.resolve(!this.$v.$error)
    },
    async handleSubmit(e) {
      this.submitted = true
      const valid = await this.isValid()
      this.isBusy = false

      
      if(this.form.contribuyente.rfc === null || this.form.contribuyente.rfc === ''){

        Vue.swal({
          type: 'error',
          title: '',
          text: 'Debe capturar un RFC en mayusculas',
          confirmButtonClass: 'btn btn-confirm mt-2',
        })
        return 

      }

      if(!this.form.contribuyente.rfc.match(/^([A-ZÑ\x26]{3,4}([0-9]{2})(0[1-9]|1[0-2])(0[1-9]|1[0-9]|2[0-9]|3[0-1])([A-Z]|[0-9]){2}([A]|[0-9]){1})?$/)){
        Vue.swal({
          type: 'error',
          title: '',
          text: 'Debe capturar un RFC en mayusculas',
          confirmButtonClass: 'btn btn-confirm mt-2',
        })
        return 

      }

      if (valid) {
        this.isBusy = true
        return axios
          .post(appConfig.recursosApi.pago, this.form)
          .then((response) => {
            this.isBusy = false
            this.form = {
              fomaPago: '',
              contribuyente: {
                contribuyenteId: '',
                rfc: '',
                razonSocial: '',
              },
              conceptos: [],
              importe: 0.0,
              importeFormat: '$0.00',
              tipoPago: '',
              estado: '',              
            }
            window.open(
              appConfig.recursosApi.urlPrincipal + '/Reportes/recibo/'+ response.data.id,
              '_blank',
              'location=yes,height=570,width=520,scrollbars=yes,status=yes'
            )
            this.$router.push('/pagos/add')
            
          })
          .catch(() => {
            this.isBusy = false
            Vue.swal({
              type: 'error',
              title: 'Oops...',
              text: 'Ocurrio un error al intentar guardar los datos.',
              confirmButtonClass: 'btn btn-confirm mt-2',
            })
          })
      }
    },
    loadConceptos(query = '') {
      this.isLoadingComboConceptos = true
      this.requestComboConceptos.filter = query
      axios
        .get(appConfig.recursosApi.conceptos, {
          params: this.requestComboConceptos,
        })
        .then((response) => {
          this.listadoConceptos = response.data.result
          this.isLoadingComboConceptos = false
          return this.data
        })
        .catch(() => {
          this.listadoConceptos = []
          this.isLoadingComboConceptos = false
          // Si ocurre algun error al cargar el listado mandamos un error 500 a la vista.
          //                     this.$router.push('/500');
        })
    },
    loadContribuyentes(query = '') {

      if(query === null){        
        return;
      }

      if(query.length < 5){        
        return;
      }
      this.isLoadingComboContribuyentes = true
      this.requestComboContribuyentes.filter = query


      axios
        .get(appConfig.recursosApi.contribuyentes, {
          params: this.requestComboContribuyentes,
        })
        .then((response) => {
          this.listadoContribuyentes = response.data.result
          this.isLoadingComboContribuyentes = false
          return this.data
        })
        .catch(() => {
          this.listadoContribuyentes = []
          this.isLoadingComboContribuyentes = false
          // Si ocurre algun error al cargar el listado mandamos un error 500 a la vista.
          // this.$router.push('/500')
        })
    },
    removeConcepto(index) {
      this.form.conceptos = this.form.conceptos.filter((x, i) => i !== index)
      this.total(this.form.conceptos)
    },
    isNumeric(n) {
      return n !== '' && !isNaN(parseFloat(n)) && isFinite(n)
    },
    addConcepto() {
      
      if(this.conceptoSeleccionado == null){

        Vue.swal({
          type: 'error',
          title: '',
          text: 'Debe seleccionar un concepto.',
          confirmButtonClass: 'btn btn-confirm mt-2',
        })
        return

      }
      if (!this.detallePago.descripcion) {
        Vue.swal({
          type: 'error',
          title: '',
          text: 'Debe tener una descripción.',
          confirmButtonClass: 'btn btn-confirm mt-2',
        })
        return
      }
      if (!this.isNumeric(this.detallePago.importe)) {
        Vue.swal({
          type: 'error',
          title: '',
          text: 'Debe ingresar un importe.',
          confirmButtonClass: 'btn btn-confirm mt-2',
        })
        return
      }

      if (parseFloat(this.detallePago.importe) < 0.1) {
        Vue.swal({
          type: 'error',
          title: '',
          text: 'Debe ingresar un importe mayor a cero.',
          confirmButtonClass: 'btn btn-confirm mt-2',
        })
        return
      }
      const options = { style: 'currency', currency: 'MXN' }
      const numberFormat = new Intl.NumberFormat('es-MX', options)

      var concepto = {
        conceptoId: this.conceptoSeleccionado.conceptoId,
        descripcion: this.conceptoSeleccionado.descripcion,
        observacion: this.detallePago.descripcion,
        importe: this.detallePago.importe,
        importeFormat: numberFormat.format(this.detallePago.importe),
      }
      this.form.conceptos.push(concepto)

      this.detallePago = {
        descripcion: '',
        importe: 0.0,
      }

      this.total(this.form.conceptos)
    },
    total(array) {
      let sum = 0
      array.forEach((item) => {
        sum += Number(item.importe)
      })

      const options = { style: 'currency', currency: 'MXN' }
      const numberFormat = new Intl.NumberFormat('es-MX', options)

      this.form.importe = sum
      this.form.importeFormat = numberFormat.format(sum)
      return sum
    },
  },
}
</script>
<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <form @submit.prevent="handleSubmit">
      <div class="row">
        <div class="col-lg-6">
          <div class="card-box">
            <h4 class="header-title m-t-0">Nuevo Cobro</h4>
            <p class="text-muted font-14 m-b-20"
              >Ingresa la información del contribuyente.</p
            >

            <!-- Datos Usuario -->
            <div class="form-row">
              <div class="form-group col-md-12">
                <label>
                  Nombre / Razon Social
                  <span class="text-danger">*</span>
                </label>
                <multiselect
                  id="contribuyente"
                  v-model="form.contribuyente"
                  label="razonSocial"
                  track-by="contribuyenteId"
                  placeholder="Teclea  nombre"
                  open-direction="bottom"
                  deselect-label=" X "
                  select-label=" + "
                  selected-label=" Seleccionado"
                  :options="listadoContribuyentes"
                  :multiple="false"
                  :searchable="true"
                  :loading="isLoadingComboContribuyentes"
                  :internal-search="false"
                  :clear-on-select="false"
                  :close-on-select="true"
                  :options-limit="100"
                  :limit="3"
                  :max-height="500"
                  :show-no-results="true"
                  :hide-selected="false"
                  @search-change="loadContribuyentes"
                >
                  <span slot="noResult">No se encontraron resultados.</span>
                  <span slot="noOptions"
                    >No se encontraron contribuyentes.</span
                  >
                </multiselect>
              </div>
            </div>
            <div class="form-row">
              <div class="form-group col-md-6">
                <label for="name">
                  RFCs
                  <span class="text-danger">*</span>
                </label>
                <input
                  v-model="form.contribuyente.rfc"
                  type="text"
                  name="rfc"
                  class="form-control"
                  placeholder=""                  
                />
                
              </div>
              <div class="form-group col-md-6"> </div>
            </div>            
            <div class="form-row">
              <div class="form-group col-md-6">
                <label>
                  Forma de Pago
                  <span class="text-danger">*</span>
                </label>

                <!-- Realizar el cambio a una llamada desde la bd-->
                <select
                  v-model="form.tipoPago"
                  type="number"
                  name="tipoPago"
                  class="custom-select"
                  :class="{
                    'is-invalid': submitted && $v.form.tipoPago.$error,
                  }"
                >
                  <option value="EFECTIVO">EFECTIVO</option>
                  <option value="TARJETA CREDITO">TARJETA CREDITO</option>
                  <option value="TARJETA DEBITO">TARJETA DEBITO</option>
                  <option value="TRANSFERENCIA">TRANSFERENCIA</option>
                  <option value="CHEQUE">CHEQUE</option>
                </select>
                <div
                  v-if="submitted && $v.form.tipoPago.$error"
                  class="invalid-feedback"
                >
                  <span v-if="!$v.form.tipoPago.required"
                    >Debe seleccionar la forma de pago.</span
                  >
                </div>
              </div>

              <div class="form-group col-md-6">
                <label>
                  Estado
                  <span class="text-danger">*</span>
                </label>

                <!-- Realizar el cambio a una llamada desde la bd-->
                <select
                  v-model="form.estado"
                  type="number"
                  name="TipoId"
                  class="custom-select"
                  placeholder="Estado."
                  :class="{
                    'is-invalid': submitted && $v.form.estado.$error,
                  }"
                >
                  <option value="PAGADO">PAGADO</option>
                  <option value="TRANSITO">TRANSITO</option>
                </select>
                <div
                  v-if="submitted && $v.form.estado.$error"
                  class="invalid-feedback"
                >
                  <span v-if="!$v.form.estado.required"
                    >Debe seleccionar el estado.</span
                  >
                </div>
              </div>
            </div>
          </div>
          <!-- end card-box -->
        </div>
      </div>
      <div class="row">
        <div class="col-lg-12">
          <div class="card-box">
            <h4 class="header-title m-t-0">Descripción</h4>
            <div
              v-if="submitted && $v.form.conceptos.$error"
              style="color: #f1556c"
            >
              <span v-if="!$v.form.conceptos.tieneConceptos"
                >Debe agregar al menos una descrpción.</span
              >
            </div>            
            <p class="text-muted font-14 m-b-20"> <!-- Datos Usuario --> </p>
            <div class="form-row">
              <div class="form-group col-md-4">
                <label for="name">
                  Concepto
                  <span class="text-danger">*</span>
                </label>
                <multiselect
                  id="concepto"
                  v-model="conceptoSeleccionado"
                  label="descripcion"
                  track-by="conceptoId"
                  placeholder=""
                  open-direction="bottom"
                  deselect-label=" X "
                  select-label=" + "
                  selected-label=" Seleccionado"
                  :options="listadoConceptos"
                  :multiple="false"
                  :searchable="true"
                  :loading="isLoadingComboConceptos"
                  :internal-search="false"
                  :clear-on-select="false"
                  :close-on-select="true"
                  :options-limit="100"
                  :limit="3"
                  :max-height="500"
                  :show-no-results="true"
                  :hide-selected="false"
                  
                  @search-change="loadConceptos"
                >
                  <span slot="noResult">No se encontraron resultados.</span>
                  <span slot="noOptions"
                    >No se encontraron resultados.</span
                  >
                </multiselect>
              </div>
              <div class="form-group col-md-5">
                <label> &nbsp; </label>
                <input
                  v-model="detallePago.descripcion"
                  type="text"
                  name="descripcion"
                  class="form-control"
                  placeholder=""
                />
              </div>
              <div class="form-group col-md-2">
                <label for="name">
                  Importe
                  <span class="text-danger">*</span>
                </label>
                <input
                  id="importe"
                  v-model="detallePago.importe"
                  name="importe"
                  class="form-control"
                  type="text"
                  placeholder=""
                />
              </div>
              <div class="form-group col-md-1">
                <div class="form-group text-right m-b-0">
                  <button
                    class="btn btn-primary"
                    type="button"
                    :disabled="isBusy"
                    @click="addConcepto"
                  >
                    <b-spinner v-show="isBusy" small></b-spinner>+
                    Agregar</button
                  >
                </div>
              </div>
            </div>
            <div class="form-row">
              <div class="table-responsive mb-0">
                <b-table
                  ref="tablaConceptos"
                  :items="form.conceptos"
                  :fields="fields"
                  responsive="sm"
                >
                  <template v-slot:cell(id)="{ index }">
                    <button
                      id="link-eliminar"
                      type="button"
                      class="btn btn-danger m-l-5 ml-1 btn-xs btn-rounded"
                      @click="removeConcepto(index)"
                    >
                      <i class="fe-x-circle"></i> Eliminar
                    </button>
                    <b-tooltip target="link-eliminar"
                      >Eliminar Concepto
                    </b-tooltip>
                  </template>
                </b-table>
              </div>
            </div>
            <div class="form-group text-right m-b-0">
              <h1>
                <span class="badge bg-danger"
                  >Total a pagar: {{ form.importeFormat }}</span
                ></h1
              >
            </div>
            <div class="form-group text-right m-b-0">
              <button class="btn btn-primary" type="submit" :disabled="isBusy">
                <b-spinner v-show="isBusy" small></b-spinner> Cobrar</button
              >
              <router-link class="btn btn-secondary m-l-5 ml-1" to="/">
                Cancelar</router-link
              >
            </div>
          </div>
          <!-- end card-box -->
        </div>
      </div>
    </form>
  </Layout>
</template>